// extracted by mini-css-extract-plugin
export default {"ripple":"style_ripple__XnYvA"};